<div class="filter-controls-wrapper flex px-2 pt-4 pb-2 radius-top-3">
  <div class="flex align-center justify-space-between wrap">
    <div class="flex align-center wrap box">
      <div *ngIf="includeSearchControl" [ngClass]="{'search-input-width':includeExportButton||includeExportMenuButton }" class="mr-1">
        <app-search-input
          placeholder=" {{ searchPlaceholder ? searchPlaceholder : 'Placeholder.DottedSearch' | translate }} "
          [showSearchActions]="showSearchActions"
          (searchValue)="onSearch($event)"
          [multiple]="isMultiple"
          [iconPosition]="'right'"
          [changePlaceholderColor]="true"
          [clearAllValues]="clearAllValues"
          [initialValue]="searchTerm"
          [allowSpaceAsSeparator]="true"
          [showValueAsTooltip]="true"
          [scrollInput]="true"
        ></app-search-input>
      </div>

      <div
        class="flex align-center date__left-spacing"
        *ngIf="includeDateControl || includePickupDateControl || includePickupDateLabel"
        [ngClass]="{'ml-8': includeSearchControl}"
      >
        <ng-container *ngIf="includePickupDateControl">
          <div class="col-auto">
            <ng-container *ngTemplateOutlet="dateFilterType"></ng-container>
          </div>
        </ng-container>

        <ng-container *ngIf="includePickupDateLabel">
          <div class="col-auto">
            <span class="small text-400 pickupdate-label">{{ PickupDateLabel }}:</span>
          </div>
        </ng-container>

        <div class="col-auto" *ngIf="includeDateControl">
          <div class="row gx-sm">
            <ng-container *ngTemplateOutlet="dateFilter"></ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="flex align-center box gaps-2">
      <ng-content select="[slot=extra-buttons]"></ng-content>

      <div *ngIf="includeExportMenuButton">
        <app-col *grantAccess="ExportButtonRole">
          <button mat-button class="text-primary-200 flex align-center" [matMenuTriggerFor]="menu">
            <app-icon name="bold-export" size="xs" class="mr-1"></app-icon>
            {{'shared.Buttons.Export' | translate}}
          </button>

          <mat-menu #menu="matMenu" (opened)="expanded = true;" (closed)="expanded = false;">
            <button mat-menu-item (click)="handleExportCsv()">
              <span>{{"shipments.AsCSV" | translate}}</span>
            </button>

            <button mat-menu-item (click)="onExportPDF()">{{'shipments.AsPDF' | translate}}</button>
          </mat-menu>
        </app-col>
      </div>

      <div class="filter-wrapper">
        <div [ngClass]="{'row': !breakControlsIntoMultipleLines}">
          <ng-container *ngIf="!breakControlsIntoMultipleLines">
            <div
              class="sort__left-spacing"
              [ngClass]="{'col-auto': !breakControlsIntoMultipleLines ,'ml-8': includeSearchControl&&!includeDateControl}"
            >
              <ng-container *ngTemplateOutlet="sortByFilter"></ng-container>
            </div>
          </ng-container>
          <div *ngIf="includeShipmentFilter && !isB2c">
            <ng-container *ngTemplateOutlet="filterButton"></ng-container>
          </div>

          <app-filter-button
            [ngClass]="{'col-auto': !breakControlsIntoMultipleLines}"
            [filterNavigationConfig]="filterNavigationConfig"
            [isPrimaryLightColor]="true"
            *ngIf="includeFilterButton && !includeShipmentFilter && !isB2c"
          ></app-filter-button>
        </div>
      </div>

      <div *ngIf="includeExportButton">
        <app-col *grantAccess="ExportButtonRole">
          <button mat-button class="text-primary-200 flex align-center" (click)="onHandleExport()">
            <app-icon name="bold-export" size="xs" class="mr-1"></app-icon>
            {{'shared.Buttons.Export' | translate}}
          </button>
        </app-col>
      </div>
    </div>
  </div>

  <div
    *ngIf="breakControlsIntoMultipleLines"
    class="flex align-center mt-3 dropdown__container justify-space-between scrollable scrollable--x overflow-y-hidden"
  >
    <div class="flex align-center">
      <ng-content select="[slot=dropdown]"></ng-content>

      <div class="mx-3" *ngIf="includeLastRefreshTimeShipmentList">
        <mat-slide-toggle color="primary" (change)="autoUpdateChanges($event)">{{'shared.AutoUpdate' | translate}}</mat-slide-toggle>
      </div>
    </div>
  </div>

  <ng-content select="[slot=extra-section]"></ng-content>
  <!-- <div class="col-auto refresh" *ngIf="includeLastRefreshTime">
    <span>{{ "Shipments.LastRefreshTime" | translate}}:</span>
    <span class="primary-color">{{ lastRefreshTime | date: 'dd-MMM hh:mm a' }}</span>
  </div> -->
</div>

<ng-template #dateFilter>
  <ng-container *ngIf="includeDateControl">
    <div class="date-dropdown col-auto flex align-center">
      <mat-form-field class="dropdown">
        <div class="flex align-center">
          <!-- <p matPrefix class="prefix bg-100 pl-2" *ngIf="!includePickupDateControl && !includePickupDateLabel " class="small m-0">
            {{ "Filter.Date" | translate }}
          </p> -->
          <app-icon matPrefix class="prefix text-400 bg-100 pl-1" name="calendar" size="xs"></app-icon>
        </div>
        <mat-select class="small bg-100 pr-2 pl-1" (selectionChange)="OnDateSelectionChange($event)" [value]="dateRangeValue">
          <mat-option
            class="small"
            *ngFor="let item of dateRangeType | enumToArray"
            [value]="item.value"
            [ngClass]="{'hide-option': item.key === dateRangeType.CUSTOM && !showCustomDateOption}"
          >
            <ng-container
              class="small text-400"
              *ngIf="item.key !== dateRangeType.CUSTOM || ( item.key === dateRangeType.CUSTOM && showCustomDateOption)"
            >
              {{ "Enum.DateRangeType." + item.key | translate }}
            </ng-container>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <form class="date-range-container flex justify-center column p-0" [formGroup]="form" *ngIf="dateRangeValue === dateRangeType.CUSTOM">
      <mat-form-field appearance="outline">
        <mat-date-range-input [max]="maxDate" [rangePicker]="picker">
          <input readonly formControlName="from" matInput matStartDate [placeholder]="'Placeholder.StartDate' | translate" />
          <input
            readonly
            formControlName="to"
            (dateChange)="customDateChanged()"
            matInput
            matEndDate
            [placeholder]="'Placeholder.EndDate' | translate"
          />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
    </form>

    <div class="col-auto" *ngIf="dateRangeValue !== dateRangeType.CUSTOM">
      <small class="py-3 d-inline-block text-primary">{{previewSelectedDate}}</small>
    </div>
  </ng-container>
</ng-template>

<ng-template #dateFilterType>
  <div class="date-dropdown" *ngIf="includePickupDateControl">
    <mat-form-field class="dropdown">
      <mat-select
        class="small bg-100 px-2 radius-1"
        (selectionChange)="selectedShipmentDateFilterTypeChanged.emit($event.value)"
        [value]="shipmentDateFilterTypeValue"
      >
        <mat-option class="small" *ngFor="let item of ShipmentDateFilterType | enumToArray" [value]="item.value">
          {{ "Enum.ShipmentDateFilterType." + item.key | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</ng-template>

<ng-template #sortByFilter>
  <div class="sort-by col-auto" *ngIf="includeSortByControl">
    <mat-form-field appearance="outline" class="flex row small">
      <p matPrefix class="sort-by-prefix small">{{ "Table.SortByPrefix" | translate }}</p>
      <mat-select class="small" (selectionChange)="onSelectSortBy($event.value)" [value]="sortOptions.MostRecent">
        <mat-option class="small" *ngFor="let item of sortOptions | enumToArray" [value]="item.value">
          {{ "Enum.SortOptions." + item.key | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</ng-template>

<ng-template #filterButton>
  <app-filter-button
    [isPrimaryLightColor]="true"
    [popoverTrigger]="popover"
    #popoverTrigger="popoverTrigger"
    size="xs"
    [closeOnClickOutside]="true"
    [position]="position"
  ></app-filter-button>
  <ng-template #popover>
    <div class="popover-container">
      <app-shipment-list-filter (closeFilter)="popoverTrigger.detachOverlay()"></app-shipment-list-filter>
    </div>
  </ng-template>
</ng-template>
